// extracted by mini-css-extract-plugin
export default {"container":"pageSearch_container__tV7ir","input":"pageSearch_input__vSpuN","counter":"pageSearch_counter__rbo--","textHighlight":"pageSearch_textHighlight__k2OUs"};